import { c as A } from "./@contentful-cca97bae.js";
var c = {}, v = {}, y = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var t = Object.prototype.hasOwnProperty;
  n.has = function(u, l) {
    return t.call(u, l);
  };
  function e(u, l) {
    return u < l ? -1 : u === l ? 0 : 1;
  }
  n.defaultCompare = e;
  function r(u, l) {
    return u === l;
  }
  n.defaultEquals = r;
  function i(u) {
    return u === null ? "COLLECTION_NULL" : a(u) ? "COLLECTION_UNDEFINED" : h(u) ? "$s" + u : "$o" + u.toString();
  }
  n.defaultToString = i;
  function o(u, l) {
    if (l === void 0 && (l = ","), u === null)
      return "COLLECTION_NULL";
    if (a(u))
      return "COLLECTION_UNDEFINED";
    if (h(u))
      return u.toString();
    var p = "{", T = !0;
    for (var _ in u)
      n.has(u, _) && (T ? T = !1 : p = p + l, p = p + _ + ":" + u[_]);
    return p + "}";
  }
  n.makeString = o;
  function s(u) {
    return typeof u == "function";
  }
  n.isFunction = s;
  function a(u) {
    return typeof u > "u";
  }
  n.isUndefined = a;
  function h(u) {
    return Object.prototype.toString.call(u) === "[object String]";
  }
  n.isString = h;
  function d(u) {
    return a(u) || !s(u) ? function(l, p) {
      return l < p ? 1 : l === p ? 0 : -1;
    } : function(l, p) {
      return u(l, p) * -1;
    };
  }
  n.reverseCompareFunction = d;
  function I(u) {
    return function(l, p) {
      return u(l, p) === 0;
    };
  }
  n.compareToEquals = I;
})(y);
Object.defineProperty(v, "__esModule", { value: !0 });
var O = y;
function F(n, t, e) {
  for (var r = e || O.defaultEquals, i = n.length, o = 0; o < i; o++)
    if (r(n[o], t))
      return o;
  return -1;
}
v.indexOf = F;
function G(n, t, e) {
  for (var r = e || O.defaultEquals, i = n.length, o = i - 1; o >= 0; o--)
    if (r(n[o], t))
      return o;
  return -1;
}
v.lastIndexOf = G;
function J(n, t, e) {
  return F(n, t, e) >= 0;
}
v.contains = J;
function X(n, t, e) {
  var r = F(n, t, e);
  return r < 0 ? !1 : (n.splice(r, 1), !0);
}
v.remove = X;
function Y(n, t, e) {
  for (var r = e || O.defaultEquals, i = n.length, o = 0, s = 0; s < i; s++)
    r(n[s], t) && o++;
  return o;
}
v.frequency = Y;
function Z(n, t, e) {
  var r = e || O.defaultEquals;
  if (n.length !== t.length)
    return !1;
  for (var i = n.length, o = 0; o < i; o++)
    if (!r(n[o], t[o]))
      return !1;
  return !0;
}
v.equals = Z;
function K(n) {
  return n.concat();
}
v.copy = K;
function tt(n, t, e) {
  if (t < 0 || t >= n.length || e < 0 || e >= n.length)
    return !1;
  var r = n[t];
  return n[t] = n[e], n[e] = r, !0;
}
v.swap = tt;
function et(n) {
  return "[" + n.toString() + "]";
}
v.toString = et;
function rt(n, t) {
  for (var e = 0, r = n; e < r.length; e++) {
    var i = r[e];
    if (t(i) === !1)
      return;
  }
}
v.forEach = rt;
var U = {}, N = {};
Object.defineProperty(N, "__esModule", { value: !0 });
var E = y, nt = (
  /** @class */
  function() {
    function n(t) {
      this.table = {}, this.nElements = 0, this.toStr = t || E.defaultToString;
    }
    return n.prototype.getValue = function(t) {
      var e = this.table["$" + this.toStr(t)];
      if (!E.isUndefined(e))
        return e.value;
    }, n.prototype.setValue = function(t, e) {
      if (!(E.isUndefined(t) || E.isUndefined(e))) {
        var r, i = "$" + this.toStr(t), o = this.table[i];
        return E.isUndefined(o) ? (this.nElements++, r = void 0) : r = o.value, this.table[i] = {
          key: t,
          value: e
        }, r;
      }
    }, n.prototype.remove = function(t) {
      var e = "$" + this.toStr(t), r = this.table[e];
      if (!E.isUndefined(r))
        return delete this.table[e], this.nElements--, r.value;
    }, n.prototype.keys = function() {
      var t = [];
      for (var e in this.table)
        if (E.has(this.table, e)) {
          var r = this.table[e];
          t.push(r.key);
        }
      return t;
    }, n.prototype.values = function() {
      var t = [];
      for (var e in this.table)
        if (E.has(this.table, e)) {
          var r = this.table[e];
          t.push(r.value);
        }
      return t;
    }, n.prototype.forEach = function(t) {
      for (var e in this.table)
        if (E.has(this.table, e)) {
          var r = this.table[e], i = t(r.key, r.value);
          if (i === !1)
            return;
        }
    }, n.prototype.containsKey = function(t) {
      return !E.isUndefined(this.getValue(t));
    }, n.prototype.clear = function() {
      this.table = {}, this.nElements = 0;
    }, n.prototype.size = function() {
      return this.nElements;
    }, n.prototype.isEmpty = function() {
      return this.nElements <= 0;
    }, n.prototype.toString = function() {
      var t = "{";
      return this.forEach(function(e, r) {
        t += `
	` + e + " : " + r;
      }), t + `
}`;
    }, n;
  }()
);
N.default = nt;
var k = {};
Object.defineProperty(k, "__esModule", { value: !0 });
var it = y, ot = v, st = N, ut = (
  /** @class */
  function() {
    function n(t) {
      this.dictionary = new st.default(t);
    }
    return n.prototype.contains = function(t) {
      return this.dictionary.containsKey(t);
    }, n.prototype.add = function(t) {
      return this.contains(t) || it.isUndefined(t) ? !1 : (this.dictionary.setValue(t, t), !0);
    }, n.prototype.intersection = function(t) {
      var e = this;
      this.forEach(function(r) {
        return t.contains(r) || e.remove(r), !0;
      });
    }, n.prototype.union = function(t) {
      var e = this;
      t.forEach(function(r) {
        return e.add(r), !0;
      });
    }, n.prototype.difference = function(t) {
      var e = this;
      t.forEach(function(r) {
        return e.remove(r), !0;
      });
    }, n.prototype.isSubsetOf = function(t) {
      if (this.size() > t.size())
        return !1;
      var e = !0;
      return this.forEach(function(r) {
        return t.contains(r) ? !0 : (e = !1, !1);
      }), e;
    }, n.prototype.remove = function(t) {
      return this.contains(t) ? (this.dictionary.remove(t), !0) : !1;
    }, n.prototype.forEach = function(t) {
      this.dictionary.forEach(function(e, r) {
        return t(r);
      });
    }, n.prototype.toArray = function() {
      return this.dictionary.values();
    }, n.prototype.isEmpty = function() {
      return this.dictionary.isEmpty();
    }, n.prototype.size = function() {
      return this.dictionary.size();
    }, n.prototype.clear = function() {
      this.dictionary.clear();
    }, n.prototype.toString = function() {
      return ot.toString(this.toArray());
    }, n;
  }()
);
k.default = ut;
Object.defineProperty(U, "__esModule", { value: !0 });
var C = y, at = N, ft = k, lt = (
  /** @class */
  function() {
    function n(t) {
      this.toStrF = t || C.defaultToString, this.dictionary = new at.default(this.toStrF), this.nElements = 0;
    }
    return n.prototype.add = function(t, e) {
      if (e === void 0 && (e = 1), C.isUndefined(t) || e <= 0)
        return !1;
      if (this.contains(t))
        this.dictionary.getValue(t).copies += e;
      else {
        var r = {
          value: t,
          copies: e
        };
        this.dictionary.setValue(t, r);
      }
      return this.nElements += e, !0;
    }, n.prototype.count = function(t) {
      return this.contains(t) ? this.dictionary.getValue(t).copies : 0;
    }, n.prototype.contains = function(t) {
      return this.dictionary.containsKey(t);
    }, n.prototype.remove = function(t, e) {
      if (e === void 0 && (e = 1), C.isUndefined(t) || e <= 0)
        return !1;
      if (this.contains(t)) {
        var r = this.dictionary.getValue(t);
        return e > r.copies ? this.nElements -= r.copies : this.nElements -= e, r.copies -= e, r.copies <= 0 && this.dictionary.remove(t), !0;
      } else
        return !1;
    }, n.prototype.toArray = function() {
      for (var t = [], e = this.dictionary.values(), r = 0, i = e; r < i.length; r++)
        for (var o = i[r], s = o.value, a = o.copies, h = 0; h < a; h++)
          t.push(s);
      return t;
    }, n.prototype.toSet = function() {
      for (var t = new ft.default(this.toStrF), e = this.dictionary.values(), r = 0, i = e; r < i.length; r++) {
        var o = i[r], s = o.value;
        t.add(s);
      }
      return t;
    }, n.prototype.forEach = function(t) {
      this.dictionary.forEach(function(e, r) {
        for (var i = r.value, o = r.copies, s = 0; s < o; s++)
          if (t(i) === !1)
            return !1;
        return !0;
      });
    }, n.prototype.size = function() {
      return this.nElements;
    }, n.prototype.isEmpty = function() {
      return this.nElements === 0;
    }, n.prototype.clear = function() {
      this.nElements = 0, this.dictionary.clear();
    }, n;
  }()
);
U.default = lt;
var M = {}, R = {}, w = {}, S = {};
Object.defineProperty(S, "__esModule", { value: !0 });
var g = y, ht = v, pt = (
  /** @class */
  function() {
    function n() {
      this.firstNode = null, this.lastNode = null, this.nElements = 0;
    }
    return n.prototype.add = function(t, e) {
      if (g.isUndefined(e) && (e = this.nElements), e < 0 || e > this.nElements || g.isUndefined(t))
        return !1;
      var r = this.createNode(t);
      if (this.nElements === 0 || this.lastNode === null)
        this.firstNode = r, this.lastNode = r;
      else if (e === this.nElements)
        this.lastNode.next = r, this.lastNode = r;
      else if (e === 0)
        r.next = this.firstNode, this.firstNode = r;
      else {
        var i = this.nodeAtIndex(e - 1);
        if (i === null)
          return !1;
        r.next = i.next, i.next = r;
      }
      return this.nElements++, !0;
    }, n.prototype.first = function() {
      if (this.firstNode !== null)
        return this.firstNode.element;
    }, n.prototype.last = function() {
      if (this.lastNode !== null)
        return this.lastNode.element;
    }, n.prototype.elementAtIndex = function(t) {
      var e = this.nodeAtIndex(t);
      if (e !== null)
        return e.element;
    }, n.prototype.indexOf = function(t, e) {
      var r = e || g.defaultEquals;
      if (g.isUndefined(t))
        return -1;
      for (var i = this.firstNode, o = 0; i !== null; ) {
        if (r(i.element, t))
          return o;
        o++, i = i.next;
      }
      return -1;
    }, n.prototype.contains = function(t, e) {
      return this.indexOf(t, e) >= 0;
    }, n.prototype.remove = function(t, e) {
      var r = e || g.defaultEquals;
      if (this.nElements < 1 || g.isUndefined(t))
        return !1;
      for (var i = null, o = this.firstNode; o !== null; ) {
        if (r(o.element, t))
          return i === null ? (this.firstNode = o.next, o === this.lastNode && (this.lastNode = null)) : o === this.lastNode ? (this.lastNode = i, i.next = o.next, o.next = null) : (i.next = o.next, o.next = null), this.nElements--, !0;
        i = o, o = o.next;
      }
      return !1;
    }, n.prototype.clear = function() {
      this.firstNode = null, this.lastNode = null, this.nElements = 0;
    }, n.prototype.equals = function(t, e) {
      var r = e || g.defaultEquals;
      return !(t instanceof n) || this.size() !== t.size() ? !1 : this.equalsAux(this.firstNode, t.firstNode, r);
    }, n.prototype.equalsAux = function(t, e, r) {
      for (; t !== null && e !== null; ) {
        if (!r(t.element, e.element))
          return !1;
        t = t.next, e = e.next;
      }
      return !0;
    }, n.prototype.removeElementAtIndex = function(t) {
      if (!(t < 0 || t >= this.nElements || this.firstNode === null || this.lastNode === null)) {
        var e;
        if (this.nElements === 1)
          e = this.firstNode.element, this.firstNode = null, this.lastNode = null;
        else {
          var r = this.nodeAtIndex(t - 1);
          r === null ? (e = this.firstNode.element, this.firstNode = this.firstNode.next) : r.next === this.lastNode && (e = this.lastNode.element, this.lastNode = r), r !== null && r.next !== null && (e = r.next.element, r.next = r.next.next);
        }
        return this.nElements--, e;
      }
    }, n.prototype.forEach = function(t) {
      for (var e = this.firstNode; e !== null && t(e.element) !== !1; )
        e = e.next;
    }, n.prototype.reverse = function() {
      for (var t = null, e = this.firstNode, r = null; e !== null; )
        r = e.next, e.next = t, t = e, e = r;
      r = this.firstNode, this.firstNode = this.lastNode, this.lastNode = r;
    }, n.prototype.toArray = function() {
      for (var t = [], e = this.firstNode; e !== null; )
        t.push(e.element), e = e.next;
      return t;
    }, n.prototype.size = function() {
      return this.nElements;
    }, n.prototype.isEmpty = function() {
      return this.nElements <= 0;
    }, n.prototype.toString = function() {
      return ht.toString(this.toArray());
    }, n.prototype.nodeAtIndex = function(t) {
      if (t < 0 || t >= this.nElements)
        return null;
      if (t === this.nElements - 1)
        return this.lastNode;
      for (var e = this.firstNode, r = 0; r < t && e !== null; r++)
        e = e.next;
      return e;
    }, n.prototype.createNode = function(t) {
      return {
        element: t,
        next: null
      };
    }, n;
  }()
);
S.default = pt;
Object.defineProperty(w, "__esModule", { value: !0 });
var dt = S, ct = (
  /** @class */
  function() {
    function n() {
      this.list = new dt.default();
    }
    return n.prototype.enqueue = function(t) {
      return this.list.add(t);
    }, n.prototype.add = function(t) {
      return this.list.add(t);
    }, n.prototype.dequeue = function() {
      if (this.list.size() !== 0) {
        var t = this.list.first();
        return this.list.removeElementAtIndex(0), t;
      }
    }, n.prototype.peek = function() {
      if (this.list.size() !== 0)
        return this.list.first();
    }, n.prototype.size = function() {
      return this.list.size();
    }, n.prototype.contains = function(t, e) {
      return this.list.contains(t, e);
    }, n.prototype.isEmpty = function() {
      return this.list.size() <= 0;
    }, n.prototype.clear = function() {
      this.list.clear();
    }, n.prototype.forEach = function(t) {
      this.list.forEach(t);
    }, n;
  }()
);
w.default = ct;
Object.defineProperty(R, "__esModule", { value: !0 });
var P = y, vt = w, yt = (
  /** @class */
  function() {
    function n(t) {
      this.root = null, this.compare = t || P.defaultCompare, this.nElements = 0;
    }
    return n.prototype.add = function(t) {
      return P.isUndefined(t) ? !1 : this.insertNode(this.createNode(t)) !== null ? (this.nElements++, !0) : !1;
    }, n.prototype.clear = function() {
      this.root = null, this.nElements = 0;
    }, n.prototype.isEmpty = function() {
      return this.nElements === 0;
    }, n.prototype.size = function() {
      return this.nElements;
    }, n.prototype.contains = function(t) {
      return P.isUndefined(t) ? !1 : this.searchNode(this.root, t) !== null;
    }, n.prototype.search = function(t) {
      var e = this.searchNode(this.root, t);
      if (e !== null)
        return e.element;
    }, n.prototype.remove = function(t) {
      var e = this.searchNode(this.root, t);
      return e === null ? !1 : (this.removeNode(e), this.nElements--, !0);
    }, n.prototype.inorderTraversal = function(t) {
      this.inorderTraversalAux(this.root, t, {
        stop: !1
      });
    }, n.prototype.preorderTraversal = function(t) {
      this.preorderTraversalAux(this.root, t, {
        stop: !1
      });
    }, n.prototype.postorderTraversal = function(t) {
      this.postorderTraversalAux(this.root, t, {
        stop: !1
      });
    }, n.prototype.levelTraversal = function(t) {
      this.levelTraversalAux(this.root, t);
    }, n.prototype.minimum = function() {
      if (!(this.isEmpty() || this.root === null))
        return this.minimumAux(this.root).element;
    }, n.prototype.maximum = function() {
      if (!(this.isEmpty() || this.root === null))
        return this.maximumAux(this.root).element;
    }, n.prototype.forEach = function(t) {
      this.inorderTraversal(t);
    }, n.prototype.toArray = function() {
      var t = [];
      return this.inorderTraversal(function(e) {
        return t.push(e), !0;
      }), t;
    }, n.prototype.height = function() {
      return this.heightAux(this.root);
    }, n.prototype.searchNode = function(t, e) {
      for (var r = 1; t !== null && r !== 0; )
        r = this.compare(e, t.element), r < 0 ? t = t.leftCh : r > 0 && (t = t.rightCh);
      return t;
    }, n.prototype.transplant = function(t, e) {
      t.parent === null ? this.root = e : t === t.parent.leftCh ? t.parent.leftCh = e : t.parent.rightCh = e, e !== null && (e.parent = t.parent);
    }, n.prototype.removeNode = function(t) {
      if (t.leftCh === null)
        this.transplant(t, t.rightCh);
      else if (t.rightCh === null)
        this.transplant(t, t.leftCh);
      else {
        var e = this.minimumAux(t.rightCh);
        e.parent !== t && (this.transplant(e, e.rightCh), e.rightCh = t.rightCh, e.rightCh.parent = e), this.transplant(t, e), e.leftCh = t.leftCh, e.leftCh.parent = e;
      }
    }, n.prototype.inorderTraversalAux = function(t, e, r) {
      t === null || r.stop || (this.inorderTraversalAux(t.leftCh, e, r), !r.stop && (r.stop = e(t.element) === !1, !r.stop && this.inorderTraversalAux(t.rightCh, e, r)));
    }, n.prototype.levelTraversalAux = function(t, e) {
      var r = new vt.default();
      for (t !== null && r.enqueue(t), t = r.dequeue() || null; t != null; ) {
        if (e(t.element) === !1)
          return;
        t.leftCh !== null && r.enqueue(t.leftCh), t.rightCh !== null && r.enqueue(t.rightCh), t = r.dequeue() || null;
      }
    }, n.prototype.preorderTraversalAux = function(t, e, r) {
      t === null || r.stop || (r.stop = e(t.element) === !1, !r.stop && (this.preorderTraversalAux(t.leftCh, e, r), !r.stop && this.preorderTraversalAux(t.rightCh, e, r)));
    }, n.prototype.postorderTraversalAux = function(t, e, r) {
      t === null || r.stop || (this.postorderTraversalAux(t.leftCh, e, r), !r.stop && (this.postorderTraversalAux(t.rightCh, e, r), !r.stop && (r.stop = e(t.element) === !1)));
    }, n.prototype.minimumAux = function(t) {
      for (; t != null && t.leftCh !== null; )
        t = t.leftCh;
      return t;
    }, n.prototype.maximumAux = function(t) {
      for (; t != null && t.rightCh !== null; )
        t = t.rightCh;
      return t;
    }, n.prototype.heightAux = function(t) {
      return t === null ? -1 : Math.max(this.heightAux(t.leftCh), this.heightAux(t.rightCh)) + 1;
    }, n.prototype.insertNode = function(t) {
      for (var e = null, r = this.root; r !== null; ) {
        var i = this.compare(t.element, r.element);
        if (i === 0)
          return null;
        i < 0 ? (e = r, r = r.leftCh) : (e = r, r = r.rightCh);
      }
      return t.parent = e, e === null ? this.root = t : this.compare(t.element, e.element) < 0 ? e.leftCh = t : e.rightCh = t, t;
    }, n.prototype.createNode = function(t) {
      return {
        element: t,
        leftCh: null,
        rightCh: null,
        parent: null
      };
    }, n;
  }()
);
R.default = yt;
var Et = A && A.__extends || function() {
  var n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
    t.__proto__ = e;
  } || function(t, e) {
    for (var r in e)
      e.hasOwnProperty(r) && (t[r] = e[r]);
  };
  return function(t, e) {
    n(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}();
Object.defineProperty(M, "__esModule", { value: !0 });
var It = R, mt = (
  /** @class */
  function(n) {
    Et(t, n);
    function t() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return t;
  }(It.default)
);
M.default = mt;
var b = {};
Object.defineProperty(b, "__esModule", { value: !0 });
var q = y, D = v, Nt = (
  /** @class */
  function() {
    function n(t) {
      this.data = [], this.compare = t || q.defaultCompare;
    }
    return n.prototype.leftChildIndex = function(t) {
      return 2 * t + 1;
    }, n.prototype.rightChildIndex = function(t) {
      return 2 * t + 2;
    }, n.prototype.parentIndex = function(t) {
      return Math.floor((t - 1) / 2);
    }, n.prototype.minIndex = function(t, e) {
      return e >= this.data.length ? t >= this.data.length ? -1 : t : this.compare(this.data[t], this.data[e]) <= 0 ? t : e;
    }, n.prototype.siftUp = function(t) {
      for (var e = this.parentIndex(t); t > 0 && this.compare(this.data[e], this.data[t]) > 0; )
        D.swap(this.data, e, t), t = e, e = this.parentIndex(t);
    }, n.prototype.siftDown = function(t) {
      for (var e = this.minIndex(this.leftChildIndex(t), this.rightChildIndex(t)); e >= 0 && this.compare(this.data[t], this.data[e]) > 0; )
        D.swap(this.data, e, t), t = e, e = this.minIndex(this.leftChildIndex(t), this.rightChildIndex(t));
    }, n.prototype.peek = function() {
      if (this.data.length > 0)
        return this.data[0];
    }, n.prototype.add = function(t) {
      return q.isUndefined(t) ? !1 : (this.data.push(t), this.siftUp(this.data.length - 1), !0);
    }, n.prototype.removeRoot = function() {
      if (this.data.length > 0) {
        var t = this.data[0];
        return this.data[0] = this.data[this.data.length - 1], this.data.splice(this.data.length - 1, 1), this.data.length > 0 && this.siftDown(0), t;
      }
    }, n.prototype.contains = function(t) {
      var e = q.compareToEquals(this.compare);
      return D.contains(this.data, t, e);
    }, n.prototype.size = function() {
      return this.data.length;
    }, n.prototype.isEmpty = function() {
      return this.data.length <= 0;
    }, n.prototype.clear = function() {
      this.data.length = 0;
    }, n.prototype.forEach = function(t) {
      D.forEach(this.data, t);
    }, n;
  }()
);
b.default = Nt;
var j = {}, _t = A && A.__extends || function() {
  var n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
    t.__proto__ = e;
  } || function(t, e) {
    for (var r in e)
      e.hasOwnProperty(r) && (t[r] = e[r]);
  };
  return function(t, e) {
    n(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}();
Object.defineProperty(j, "__esModule", { value: !0 });
var gt = N, x = y, xt = (
  /** @class */
  function() {
    function n(t, e) {
      this.key = t, this.value = e;
    }
    return n.prototype.unlink = function() {
      this.prev.next = this.next, this.next.prev = this.prev;
    }, n;
  }()
), W = (
  /** @class */
  function() {
    function n() {
      this.key = null, this.value = null;
    }
    return n.prototype.unlink = function() {
      this.prev.next = this.next, this.next.prev = this.prev;
    }, n;
  }()
);
function At(n) {
  return !n.next;
}
var Tt = (
  /** @class */
  function(n) {
    _t(t, n);
    function t(e) {
      var r = n.call(this, e) || this;
      return r.head = new W(), r.tail = new W(), r.head.next = r.tail, r.tail.prev = r.head, r;
    }
    return t.prototype.appendToTail = function(e) {
      var r = this.tail.prev;
      r.next = e, e.prev = r, e.next = this.tail, this.tail.prev = e;
    }, t.prototype.getLinkedDictionaryPair = function(e) {
      if (!x.isUndefined(e)) {
        var r = "$" + this.toStr(e), i = this.table[r];
        return i;
      }
    }, t.prototype.getValue = function(e) {
      var r = this.getLinkedDictionaryPair(e);
      if (!x.isUndefined(r))
        return r.value;
    }, t.prototype.remove = function(e) {
      var r = this.getLinkedDictionaryPair(e);
      if (!x.isUndefined(r))
        return n.prototype.remove.call(this, e), r.unlink(), r.value;
    }, t.prototype.clear = function() {
      n.prototype.clear.call(this), this.head.next = this.tail, this.tail.prev = this.head;
    }, t.prototype.replace = function(e, r) {
      var i = "$" + this.toStr(r.key);
      r.next = e.next, r.prev = e.prev, this.remove(e.key), r.prev.next = r, r.next.prev = r, this.table[i] = r, ++this.nElements;
    }, t.prototype.setValue = function(e, r) {
      if (!(x.isUndefined(e) || x.isUndefined(r))) {
        var i = this.getLinkedDictionaryPair(e), o = new xt(e, r), s = "$" + this.toStr(e);
        if (x.isUndefined(i)) {
          this.appendToTail(o), this.table[s] = o, ++this.nElements;
          return;
        } else
          return this.replace(i, o), i.value;
      }
    }, t.prototype.keys = function() {
      var e = [];
      return this.forEach(function(r, i) {
        e.push(r);
      }), e;
    }, t.prototype.values = function() {
      var e = [];
      return this.forEach(function(r, i) {
        e.push(i);
      }), e;
    }, t.prototype.forEach = function(e) {
      for (var r = this.head.next; !At(r); ) {
        var i = e(r.key, r.value);
        if (i === !1)
          return;
        r = r.next;
      }
    }, t;
  }(gt.default)
);
j.default = Tt;
var B = {};
Object.defineProperty(B, "__esModule", { value: !0 });
var m = y, St = N, L = v, Dt = (
  /** @class */
  function() {
    function n(t, e, r) {
      r === void 0 && (r = !1), this.dict = new St.default(t), this.equalsF = e || m.defaultEquals, this.allowDuplicate = r;
    }
    return n.prototype.getValue = function(t) {
      var e = this.dict.getValue(t);
      return m.isUndefined(e) ? [] : L.copy(e);
    }, n.prototype.setValue = function(t, e) {
      if (m.isUndefined(t) || m.isUndefined(e))
        return !1;
      var r = this.dict.getValue(t);
      return m.isUndefined(r) ? (this.dict.setValue(t, [e]), !0) : !this.allowDuplicate && L.contains(r, e, this.equalsF) ? !1 : (r.push(e), !0);
    }, n.prototype.remove = function(t, e) {
      if (m.isUndefined(e)) {
        var r = this.dict.remove(t);
        return !m.isUndefined(r);
      }
      var i = this.dict.getValue(t);
      return !m.isUndefined(i) && L.remove(i, e, this.equalsF) ? (i.length === 0 && this.dict.remove(t), !0) : !1;
    }, n.prototype.keys = function() {
      return this.dict.keys();
    }, n.prototype.values = function() {
      for (var t = this.dict.values(), e = [], r = 0, i = t; r < i.length; r++)
        for (var o = i[r], s = 0, a = o; s < a.length; s++) {
          var h = a[s];
          e.push(h);
        }
      return e;
    }, n.prototype.containsKey = function(t) {
      return this.dict.containsKey(t);
    }, n.prototype.clear = function() {
      this.dict.clear();
    }, n.prototype.size = function() {
      return this.dict.size();
    }, n.prototype.isEmpty = function() {
      return this.dict.isEmpty();
    }, n;
  }()
);
B.default = Dt;
var $ = {}, Ot = A && A.__extends || function() {
  var n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
    t.__proto__ = e;
  } || function(t, e) {
    for (var r in e)
      e.hasOwnProperty(r) && (t[r] = e[r]);
  };
  return function(t, e) {
    n(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}();
Object.defineProperty($, "__esModule", { value: !0 });
var kt = N, Rt = y, wt = (
  /** @class */
  function(n) {
    Ot(t, n);
    function t(e, r) {
      var i = n.call(this, r) || this;
      return i.defaultFactoryFunction = e, i;
    }
    return t.prototype.setDefault = function(e, r) {
      var i = n.prototype.getValue.call(this, e);
      return Rt.isUndefined(i) ? (this.setValue(e, r), r) : i;
    }, t.prototype.getValue = function(e) {
      return this.setDefault(e, this.defaultFactoryFunction());
    }, t;
  }(kt.default)
);
$.default = wt;
var z = {};
Object.defineProperty(z, "__esModule", { value: !0 });
var bt = y, $t = b, Ct = (
  /** @class */
  function() {
    function n(t) {
      this.heap = new $t.default(bt.reverseCompareFunction(t));
    }
    return n.prototype.enqueue = function(t) {
      return this.heap.add(t);
    }, n.prototype.add = function(t) {
      return this.heap.add(t);
    }, n.prototype.dequeue = function() {
      if (this.heap.size() !== 0) {
        var t = this.heap.peek();
        return this.heap.removeRoot(), t;
      }
    }, n.prototype.peek = function() {
      return this.heap.peek();
    }, n.prototype.contains = function(t) {
      return this.heap.contains(t);
    }, n.prototype.isEmpty = function() {
      return this.heap.isEmpty();
    }, n.prototype.size = function() {
      return this.heap.size();
    }, n.prototype.clear = function() {
      this.heap.clear();
    }, n.prototype.forEach = function(t) {
      this.heap.forEach(t);
    }, n;
  }()
);
z.default = Ct;
var V = {};
Object.defineProperty(V, "__esModule", { value: !0 });
var Pt = S, qt = (
  /** @class */
  function() {
    function n() {
      this.list = new Pt.default();
    }
    return n.prototype.push = function(t) {
      return this.list.add(t, 0);
    }, n.prototype.add = function(t) {
      return this.list.add(t, 0);
    }, n.prototype.pop = function() {
      return this.list.removeElementAtIndex(0);
    }, n.prototype.peek = function() {
      return this.list.first();
    }, n.prototype.size = function() {
      return this.list.size();
    }, n.prototype.contains = function(t, e) {
      return this.list.contains(t, e);
    }, n.prototype.isEmpty = function() {
      return this.list.isEmpty();
    }, n.prototype.clear = function() {
      this.list.clear();
    }, n.prototype.forEach = function(t) {
      this.list.forEach(t);
    }, n;
  }()
);
V.default = qt;
var Q = {};
Object.defineProperty(Q, "__esModule", { value: !0 });
var f;
(function(n) {
  n[n.BEFORE = 0] = "BEFORE", n[n.AFTER = 1] = "AFTER", n[n.INSIDE_AT_END = 2] = "INSIDE_AT_END", n[n.INSIDE_AT_START = 3] = "INSIDE_AT_START";
})(f || (f = {}));
var Lt = (
  /** @class */
  function() {
    function n(t, e) {
      t === void 0 && (t = []), e === void 0 && (e = {}), this.rootIds = t, this.nodes = e, this.initRootIds(), this.initNodes();
    }
    return n.prototype.initRootIds = function() {
      for (var t = 0, e = this.rootIds; t < e.length; t++) {
        var r = e[t];
        this.createEmptyNodeIfNotExist(r);
      }
    }, n.prototype.initNodes = function() {
      for (var t in this.nodes)
        if (this.nodes.hasOwnProperty(t))
          for (var e = 0, r = this.nodes[t]; e < r.length; e++) {
            var i = r[e];
            this.createEmptyNodeIfNotExist(i);
          }
    }, n.prototype.createEmptyNodeIfNotExist = function(t) {
      this.nodes[t] || (this.nodes[t] = []);
    }, n.prototype.getRootIds = function() {
      var t = this.rootIds.slice();
      return t;
    }, n.prototype.getNodes = function() {
      var t = {};
      for (var e in this.nodes)
        this.nodes.hasOwnProperty(e) && (t[e] = this.nodes[e].slice());
      return t;
    }, n.prototype.getObject = function() {
      return {
        rootIds: this.getRootIds(),
        nodes: this.getNodes()
      };
    }, n.prototype.toObject = function() {
      return this.getObject();
    }, n.prototype.flatten = function() {
      for (var t = this, e = [], r = 0; r < this.rootIds.length; r++) {
        var i = this.rootIds[r];
        e.push({
          id: i,
          level: 0,
          hasParent: !1,
          childrenCount: 0
        }), d(i, this.nodes, e, 0);
      }
      for (var o = 0, s = e; o < s.length; o++) {
        var a = s[o];
        a.childrenCount = h(a.id);
      }
      return e;
      function h(I) {
        if (t.nodes[I]) {
          var u = t.nodes[I].length;
          return u;
        } else
          return 0;
      }
      function d(I, u, l, p) {
        if (p === void 0 && (p = 0), !(!I || !u || !l || !u[I])) {
          p++;
          for (var T = u[I], _ = 0; _ < T.length; _++) {
            var H = T[_];
            l.push({ id: H, level: p, hasParent: !0 }), d(H, u, l, p);
          }
          p--;
        }
      }
    }, n.prototype.moveIdBeforeId = function(t, e) {
      return this.moveId(t, e, f.BEFORE);
    }, n.prototype.moveIdAfterId = function(t, e) {
      return this.moveId(t, e, f.AFTER);
    }, n.prototype.moveIdIntoId = function(t, e, r) {
      return r === void 0 && (r = !0), r ? this.moveId(t, e, f.INSIDE_AT_START) : this.moveId(t, e, f.INSIDE_AT_END);
    }, n.prototype.swapRootIdWithRootId = function(t, e) {
      var r = this.findRootId(t), i = this.findRootId(e);
      this.swapRootPositionWithRootPosition(r, i);
    }, n.prototype.swapRootPositionWithRootPosition = function(t, e) {
      var r = this.rootIds[e];
      this.rootIds[e] = this.rootIds[t], this.rootIds[t] = r;
    }, n.prototype.deleteId = function(t) {
      this.rootDeleteId(t), this.nodeAndSubNodesDelete(t), this.nodeRefrencesDelete(t);
    }, n.prototype.insertIdBeforeId = function(t, e) {
      var r = this.findRootId(t);
      r > -1 && this.insertIdIntoRoot(e, r);
      for (var i in this.nodes)
        if (this.nodes.hasOwnProperty(i)) {
          var o = this.findNodeId(i, t);
          o > -1 && this.insertIdIntoNode(i, e, o);
        }
    }, n.prototype.insertIdAfterId = function(t, e) {
      var r = this.findRootId(t);
      r > -1 && this.insertIdIntoRoot(e, r + 1);
      for (var i in this.nodes)
        if (this.nodes.hasOwnProperty(i)) {
          var o = this.findNodeId(i, t);
          o > -1 && this.insertIdIntoNode(i, e, o + 1);
        }
    }, n.prototype.insertIdIntoId = function(t, e) {
      this.nodeInsertAtEnd(t, e), this.nodes[e] = [];
    }, n.prototype.insertIdIntoRoot = function(t, e) {
      if (e === void 0)
        this.rootInsertAtEnd(t);
      else if (e < 0) {
        var r = this.rootIds.length;
        this.rootIds.splice(e + r + 1, 0, t);
      } else
        this.rootIds.splice(e, 0, t);
      this.nodes[t] = this.nodes[t] || [];
    }, n.prototype.insertIdIntoNode = function(t, e, r) {
      if (this.nodes[t] = this.nodes[t] || [], this.nodes[e] = this.nodes[e] || [], r === void 0)
        this.nodeInsertAtEnd(t, e);
      else if (r < 0) {
        var i = this.nodes[t].length;
        this.nodes[t].splice(r + i + 1, 0, e);
      } else
        this.nodes[t].splice(r, 0, e);
    }, n.prototype.moveId = function(t, e, r) {
      var i = t, o = this.findRootId(i);
      this.nodes[e];
      for (var s in this.nodes)
        if (this.nodes.hasOwnProperty(s)) {
          this.findNodeId(s, e);
          break;
        }
      var a = e, h = this.findRootId(a);
      this.nodes[e];
      for (var s in this.nodes)
        if (this.nodes.hasOwnProperty(s)) {
          this.findNodeId(s, e);
          break;
        }
      if (o > -1)
        if (h > -1)
          switch (this.rootDelete(o), h > o && h--, r) {
            case f.BEFORE:
              this.insertIdIntoRoot(i, h);
              break;
            case f.AFTER:
              this.insertIdIntoRoot(i, h + 1);
              break;
            case f.INSIDE_AT_START:
              this.nodeInsertAtStart(a, i);
              break;
            case f.INSIDE_AT_END:
              this.nodeInsertAtEnd(a, i);
              break;
          }
        else {
          this.rootDelete(o);
          for (var s in this.nodes)
            if (this.nodes.hasOwnProperty(s)) {
              var d = this.findNodeId(s, a);
              if (d > -1) {
                switch (r) {
                  case f.BEFORE:
                    this.insertIdIntoNode(s, i, d);
                    break;
                  case f.AFTER:
                    this.insertIdIntoNode(s, i, d + 1);
                    break;
                  case f.INSIDE_AT_START:
                    this.nodeInsertAtStart(a, i);
                    break;
                  case f.INSIDE_AT_END:
                    this.nodeInsertAtEnd(a, i);
                    break;
                }
                break;
              }
            }
        }
      else if (h > -1) {
        for (var s in this.nodes)
          if (this.nodes.hasOwnProperty(s)) {
            var d = this.findNodeId(s, i);
            if (d > -1) {
              this.nodeDeleteAtIndex(s, d);
              break;
            }
          }
        switch (r) {
          case f.BEFORE:
            this.insertIdIntoRoot(i, h);
            break;
          case f.AFTER:
            this.insertIdIntoRoot(i, h + 1);
            break;
          case f.INSIDE_AT_START:
            this.nodeInsertAtStart(a, i);
            break;
          case f.INSIDE_AT_END:
            this.nodeInsertAtEnd(a, i);
            break;
        }
      } else {
        for (var s in this.nodes)
          if (this.nodes.hasOwnProperty(s)) {
            var d = this.findNodeId(s, i);
            if (d > -1) {
              this.nodeDeleteAtIndex(s, d);
              break;
            }
          }
        for (var s in this.nodes)
          if (this.nodes.hasOwnProperty(s)) {
            var d = this.findNodeId(s, a);
            if (d > -1) {
              switch (r) {
                case f.BEFORE:
                  this.insertIdIntoNode(s, i, d);
                  break;
                case f.AFTER:
                  this.insertIdIntoNode(s, i, d + 1);
                  break;
                case f.INSIDE_AT_START:
                  this.nodeInsertAtStart(a, i);
                  break;
                case f.INSIDE_AT_END:
                  this.nodeInsertAtEnd(a, i);
                  break;
              }
              break;
            }
          }
      }
    }, n.prototype.swapArrayElements = function(t, e, r) {
      var i = t[e];
      return t[e] = t[r], t[r] = i, t;
    }, n.prototype.rootDeleteId = function(t) {
      var e = this.findRootId(t);
      e > -1 && this.rootDelete(e);
    }, n.prototype.nodeAndSubNodesDelete = function(t) {
      for (var e = [], r = 0; r < this.nodes[t].length; r++) {
        var i = this.nodes[t][r];
        this.nodeAndSubNodesDelete(i), e.push(t);
      }
      this.nodeDelete(t);
      for (var r = 0; r < e.length; r++)
        this.nodeDelete(e[r]);
    }, n.prototype.nodeRefrencesDelete = function(t) {
      for (var e in this.nodes)
        if (this.nodes.hasOwnProperty(e))
          for (var r = 0; r < this.nodes[e].length; r++) {
            var i = this.nodes[e][r];
            i === t && this.nodeDeleteAtIndex(e, r);
          }
    }, n.prototype.nodeDelete = function(t) {
      delete this.nodes[t];
    }, n.prototype.findRootId = function(t) {
      return this.rootIds.indexOf(t);
    }, n.prototype.findNodeId = function(t, e) {
      return this.nodes[t].indexOf(e);
    }, n.prototype.findNode = function(t) {
      return this.nodes[t];
    }, n.prototype.nodeInsertAtStart = function(t, e) {
      this.nodes[t].unshift(e);
    }, n.prototype.nodeInsertAtEnd = function(t, e) {
      this.nodes[t].push(e);
    }, n.prototype.rootDelete = function(t) {
      this.rootIds.splice(t, 1);
    }, n.prototype.nodeDeleteAtIndex = function(t, e) {
      this.nodes[t].splice(e, 1);
    }, n.prototype.rootInsertAtStart = function(t) {
      this.rootIds.unshift(t);
    }, n.prototype.rootInsertAtEnd = function(t) {
      this.rootIds.push(t);
    }, n;
  }()
);
Q.default = Lt;
Object.defineProperty(c, "__esModule", { value: !0 });
var Ft = v;
c.arrays = Ft;
var Ut = U;
c.Bag = Ut.default;
var Mt = M;
c.BSTree = Mt.default;
var jt = R;
c.BSTreeKV = jt.default;
var Bt = N, re = c.Dictionary = Bt.default, zt = b;
c.Heap = zt.default;
var Vt = j;
c.LinkedDictionary = Vt.default;
var Qt = S;
c.LinkedList = Qt.default;
var Ht = B;
c.MultiDictionary = Ht.default;
var Wt = $;
c.FactoryDictionary = Wt.default;
var Gt = $;
c.DefaultDictionary = Gt.default;
var Jt = w;
c.Queue = Jt.default;
var Xt = z;
c.PriorityQueue = Xt.default;
var Yt = k;
c.Set = Yt.default;
var Zt = V;
c.Stack = Zt.default;
var Kt = Q;
c.MultiRootTree = Kt.default;
var te = y;
c.util = te;
export {
  re as D
};
